export enum BindingMode {
    oneWay = 'oneWay',
    twoWay = 'twoWay'
}